import React, { Fragment, FunctionComponent } from 'react';
import { Icon } from 'semantic-ui-react';

type ProFullNameProps = {
  name: string;
  mainCityCode?: string;
  mainTradeNames: string | undefined;
  status?: string;
};

const ProFullName: FunctionComponent<ProFullNameProps> = ({
  name,
  mainCityCode,
  mainTradeNames,
  status,
}) => {
  const mainCityCodeText = mainCityCode ? `- ${mainCityCode}` : '';
  const mainTradeNameText = mainTradeNames ? ` - ${mainTradeNames}` : '';
  return (
    <Fragment>
      {status ? (
        <Icon
          name="circle"
          size="small"
          color={
            status === 'published'
              ? 'green'
              : status === 'draft'
                ? 'red'
                : 'grey'
          }
        />
      ) : null}
      {name} {mainCityCodeText} <em>{mainTradeNameText}</em>
    </Fragment>
  );
};

export default ProFullName;
